import { WrapperEntryMapping } from '@/constants';
import type { IWrapper, WrapperEntryName } from '@/interfaces';
import { capitalize } from '@/utils';
import RichText from '../../RichText';
import WithImage from '../WithImage';

interface InnerChildProps {
  entryList: IWrapper['entryList'];
}

const InnerChild: React.FC<InnerChildProps> = ({ entryList }) => {
  const contentTypeName = entryList?.[0]?.__typename;
  const ChildOfWrapper = WrapperEntryMapping[capitalize(contentTypeName) as WrapperEntryName];
  const entryListFiltered = entryList?.filter((entry) => entry.__typename === contentTypeName);

  if (!entryListFiltered?.length || !ChildOfWrapper) return null;

  return <ChildOfWrapper data={entryListFiltered} />;
};

interface BodyComponentProps {
  image: IWrapper['image'];
  content: IWrapper['content'];
  entryList: IWrapper['entryList'];
}

const BodyComponent: React.FC<BodyComponentProps> = ({ image, content, entryList }) => {
  if (entryList?.length) {
    return <InnerChild entryList={entryList} />;
  }

  if (content) {
    return (
      <WithImage image={image}>
        <RichText richText={content} />
      </WithImage>
    );
  }

  return null;
};

export default BodyComponent;
